const isRootOperationEntity = (entity) => !entity.parentId;
const operationEntityNameCollator = new Intl.Collator('zh-CN', {
  numeric: true,
  sensitivity: 'base',
});
const compareStableText = (left, right) => Number(left > right) - Number(left < right);

const compareOperationEntities = (left, right) =>
  Number(Boolean(left.isStore)) - Number(Boolean(right.isStore)) ||
  operationEntityNameCollator.compare(left.name, right.name) ||
  compareStableText(left.code, right.code) ||
  compareStableText(left.id, right.id);

const getOperationEntityDescendantIds = (entities, entityId) => {
  const childIdsByParentId = entities.reduce((result, entity) => {
    if (!entity.parentId) {
      return result;
    }
    return {
      ...result,
      [entity.parentId]: [...(result[entity.parentId] || []), entity.id],
    };
  }, {});
  const descendantIds = new Set();
  const pendingIds = [...(childIdsByParentId[entityId] || [])];

  while (pendingIds.length) {
    const currentId = pendingIds.pop();
    descendantIds.add(currentId);
    pendingIds.push(...(childIdsByParentId[currentId] || []));
  }

  return descendantIds;
};

const buildOperationEntityTree = (entities) => {
  const childrenByParentId = entities.reduce((result, entity) => {
    const parentKey = entity.parentId || '__root__';
    return {
      ...result,
      [parentKey]: [...(result[parentKey] || []), entity],
    };
  }, {});
  const buildChildren = (parentId) =>
    (childrenByParentId[parentId || '__root__'] || [])
      .sort(compareOperationEntities)
      .map((entity) => {
        const children = buildChildren(entity.id);
        return {
          ...entity,
          ...(children.length ? { children } : {}),
        };
      });

  return buildChildren();
};

const buildVisibleOperationEntityTree = (entities) =>
  buildOperationEntityTree(entities).flatMap((root) => root.children || []);

const getOperationEntityParentOptions = (entities, entityId) => {
  const excludedIds = new Set([entityId, ...getOperationEntityDescendantIds(entities, entityId)]);
  return entities
    .filter((entity) => entity.enabled && !entity.isStore && !excludedIds.has(entity.id))
    .map((entity) => ({
      label: entity.name,
      value: entity.id,
    }));
};

export {
  buildOperationEntityTree,
  buildVisibleOperationEntityTree,
  getOperationEntityParentOptions,
  isRootOperationEntity,
};
